import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
  TableHeaderBulkSelectCheckbox,
} from '@occc-app/design-system';
import { RetailerNetworkLocationFragment } from '@occc/graphql';
import { useBulkSelect } from '@occc-app/hooks/useBulkSelect';

import LocationListItem from './location-list-item.component';

import { useGetRetailerNetworkLocations } from '../../../data-access/queries';
import { LOCATIONS_AFTER_PARAM } from '../retailer-network-locations-configuration.constants';

type LocationListProps = ReturnType<typeof useBulkSelect> & {
  locationsData: ReturnType<typeof useGetRetailerNetworkLocations>;
  handleOpenAddLocationsToLocationGroupDialog: () => void;
  onRemoveLocationMenuItemClick: (locationUuid: string) => void;
  handleOpenLocationDetailsPage: (locationUuid: string) => void;
};

const LocationList = ({
  locationsData,
  bulkSelectedItems,
  handleBulkSelectMultiple,
  handleItemSelect,
  handleOpenAddLocationsToLocationGroupDialog,
  onRemoveLocationMenuItemClick,
  handleOpenLocationDetailsPage,
}: LocationListProps) => {
  const { loading: locationsLoading, error, data, paginationProps } = locationsData;
  const currentPageLocationUuids =
    data?.map((item: RetailerNetworkLocationFragment) => item.location.uuid) || [];

  const renderData = (items: RetailerNetworkLocationFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding='checkbox'>
              <TableHeaderBulkSelectCheckbox
                bulkSelectedItems={bulkSelectedItems}
                handleBulkSelectMultiple={handleBulkSelectMultiple}
                currentPageItems={currentPageLocationUuids}
              />
            </TableCell>
            <TableCell>Site ID</TableCell>
            <TableCell>Site Name (DBA)</TableCell>
            <TableCell>Site Address</TableCell>
            <TableCell>Site Phone Number</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <LocationListItem
              location={item.location}
              key={item.location.uuid}
              isItemSelected={bulkSelectedItems.has(item.location.uuid)}
              handleItemSelect={handleItemSelect}
              handleOpenAddLocationsToLocationGroupDialog={
                handleOpenAddLocationsToLocationGroupDialog
              }
              onRemoveLocationMenuItemClick={onRemoveLocationMenuItemClick}
              handleOpenLocationDetailsPage={handleOpenLocationDetailsPage}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<RetailerNetworkLocationFragment>
      error={error}
      loading={locationsLoading}
      items={data}
      renderData={renderData}
      afterParamName={LOCATIONS_AFTER_PARAM}
    />
  );
};

export default LocationList;
